export const enum MenuItem {
    WaMessages = 'WaMessages',
    WaMessagesSetups = 'WaMessagesSetups',
    PhoneVerifications = 'PhoneVerifications',
    FailedPhoneVerifications = 'FailedPhoneVerifications',
    WaTemplatesSetups = 'WaTemplatesSetups'
}

export const Filters = {
    MOR: 'MOR',
    merchantId: 'merchantId',
    transactionStatuses: 'transactionStatuses',
    phoneFrequency: 'phoneFrequency',
    isEnabled: 'isEnabled',
    coreId: 'coreId'
};
